import React, { useEffect, useState } from 'react';
import ClientPlanner from './ClientPlanner';
import { saveClientPlannerState } from '../utils/eventService';

const CLOUD_KEYS = ['answers', 'timeline', 'songs', 'playlists'];

function readPlannerState(eventId) {
  return Object.fromEntries(CLOUD_KEYS.map((name) => {
    const storageKey = name === 'answers'
      ? `amp-planner-answers-${eventId}`
      : `amp-${name}-${eventId}`;

    try {
      return [name, JSON.parse(localStorage.getItem(storageKey) || 'null')];
    } catch {
      return [name, null];
    }
  }));
}

function ClientPlannerSync({ sections, event, token }) {
  const [syncError, setSyncError] = useState('');
  const [syncState, setSyncState] = useState('Saving to your event');

  useEffect(() => {
    let lastSaved = '';
    let active = true;
    let saveTimer;

    const save = async () => {
      const state = readPlannerState(event.id);
      if (Object.values(state).some((value) => value === null)) return;

      const serialized = JSON.stringify(state);
      if (serialized === lastSaved) return;

      try {
        await saveClientPlannerState(token, state);
        if (!active) return;
        lastSaved = serialized;
        setSyncError('');
        setSyncState('Synced with your event');
      } catch (error) {
        if (!active) return;
        setSyncError(error.message || 'Cloud sync is unavailable.');
        setSyncState('Saved on this device');
      }
    };

    save();
    const poll = window.setInterval(() => {
      window.clearTimeout(saveTimer);
      saveTimer = window.setTimeout(save, 350);
    }, 650);

    return () => {
      active = false;
      window.clearInterval(poll);
      window.clearTimeout(saveTimer);
    };
  }, [event.id, token]);

  return (
    <>
      <div className={`client-cloud-status ${syncError ? 'has-error' : ''}`} role={syncError ? 'alert' : 'status'}>
        {syncError || syncState}
      </div>
      <ClientPlanner sections={sections} event={event} />
    </>
  );
}

export default ClientPlannerSync;